import getCdnImg from './getCdnImg';

type ColorScheme = 'light' | 'dark';

type ColorSchemeRecord<T> = Record<ColorScheme, T>;

const logoPath: Partial<SiteRecord<Partial<ColorSchemeRecord<string>>>> = {
  bitcasino: { light: 'icons/logo-bitcasino.svg' },
  sportsbet: {
    dark: 'sportsbet/sportsbet-logo-circle.svg',
    light: 'sportsbet/sportsbet-logo-circle-black.svg',
  },
  livecasino: { dark: 'livecasino/logo-short.svg' },
  sportsbetmx: {
    dark: 'sportsbet/sportsbet-logo-circle.svg',
    light: 'sportsbet/sportsbet-logo-circle-black.svg',
  },
  empire: {
    light: 'empire/short-logo.svg',
  },
};

const getSiteLogo = (site: Site, colorScheme: ColorScheme = 'light') =>
  getCdnImg(
    logoPath[site]?.[colorScheme] ||
      logoPath[site]?.light ||
      logoPath[site]?.dark,
  );

export default getSiteLogo;
